import { checkIsLogged } from '@/redux/auth/auth';
import store from '@/store';

const TokenService = {
  setToken: (token: string) => {
    sessionStorage.setItem('accessToken', token);
  },
  getToken: () => sessionStorage.getItem('accessToken'),
  clearToken: () => {
    sessionStorage.removeItem('accessToken');
  },
  clearSession: () => {
    sessionStorage.clear();
    store.dispatch(checkIsLogged());
  },
};

export default TokenService;
